import React from 'react';
import { Input } from '@material-tailwind/react';

const GroupForm = ({ 
  formData, 
  handleChange, 
  handleSubmit, 
  errorMessage, 
  isEditing 
}) => {
  return (
    <div className="mb-6">
      <form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Nombre del grupo"
          required
          className="mb-4"
          label="Nombre del grupo"
        />
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Descripción del grupo"
          className="mb-4 p-2 border rounded w-full h-32"
          label="Descripción del grupo"
        />
        
        {errorMessage && <div className="text-red-500 mb-4">{errorMessage}</div>}
      </form>
    </div>
  );
};

export default GroupForm;